import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpContextToken,
} from '@angular/common/http';
import { LoadingService } from '../servicios/loading.service';
import { Observable, finalize } from 'rxjs';
import { Injectable, inject } from '@angular/core';

// Token de contexto para saltar el loading global
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService);

  private totalRequests = 0;

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Verificar si la petición debe saltar el loading global
    const skipLoading = request.context.get(SKIP_LOADING);

    if (!skipLoading) {
      this.totalRequests++;
      this.loadingService.setLoading(true);
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!skipLoading) {
          this.totalRequests--;
          if (this.totalRequests == 0) {
            this.loadingService.setLoading(false);
          }
        }
      }),
    );
  }
}
